import { render } from "./Expertise.vue?vue&type=template&id=48267513&scoped=true&ts=true"
import script from "./Expertise.vue?vue&type=script&lang=ts"
export * from "./Expertise.vue?vue&type=script&lang=ts"

import "./Expertise.vue?vue&type=style&index=0&id=48267513&lang=scss&scoped=true"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48267513"]])

export default __exports__